import script from "./productFabricCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./productFabricCategory.vue?vue&type=script&setup=true&lang=js"

import "./productFabricCategory.vue?vue&type=style&index=0&id=44778508&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44778508"]])

export default __exports__